<template>
  <div
    class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm"
    data-cy-breadcrumb
  >
    <div v-for="(item, index) in items" :key="item.label" class="inline">
      <app-icon
        v-if="index > 0"
        class="mx-1"
        icon="ph:caret-right-bold"
        :size="14"
      />
      <component
        :is="item.to ? NuxtLink : (item.tag ?? 'span')"
        class="inline"
        :class="{
          'hover:underline': !!item.to,
          'font-semibold': index === items.length - 1,
        }"
        :to="item.to"
      >
        {{ item.label }}
      </component>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { BreadcrumbItem } from "~/shared/breadcrumb/breadcrumb.model";

const NuxtLink = resolveComponent("nuxt-link");

const properties = defineProps<{
  items: BreadcrumbItem[];
}>();

const { resolve } = useRouter();

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: properties.items.map((item) => {
      return {
        name: item.label,
        item: item.to ? resolve(item.to).path : undefined,
      };
    }),
  }),
]);
</script>
